import { Menu } from '@shared/components/Menu';
import { View } from '@shared/components/View';
import { ControlOption } from '@shared/components/filter/types';
import { i18n } from '@shared/util/i18n';

interface AddMenuProps {
  title: string;
  onAdd(item: ControlOption): void;
  options: ControlOption[];
}

export function AddMenu({ title, onAdd = () => {}, options = [] }: AddMenuProps) {
  return (
    <View row>
      <Menu>
        <Menu.Button icon="plus" label={i18n('common.add')} style={{ border: 'none' }} />
        <Menu.Content>
          <Menu.Section title={title} />
          <Menu.SearchableOptions
            options={options}
            getItemKey={option => option.id}
            getItemLabel={option => option.label}
            getItemIcon={option => option.icon}
            onSelect={onAdd}
          />
        </Menu.Content>
      </Menu>
    </View>
  );
}
